export function initInstitutions() {
  const root = document.querySelector("[data-institutions]");

  if (!root) {
    return;
  }

  const gminaEls = Array.from(root.querySelectorAll("[data-gmina]"));
  const panels = Array.from(root.querySelectorAll("[data-gmina-panel]"));
  const select = root.querySelector("[data-gmina-select]");

  if (!panels.length) {
    return;
  }

  const activate = (slug) => {
    gminaEls.forEach((el) => {
      const on = el.dataset.gmina === slug;
      el.classList.toggle("is-active", on);
      el.setAttribute("aria-pressed", on ? "true" : "false");
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.gminaPanel !== slug;
    });

    if (select && select.value !== slug) {
      select.value = slug;
    }
  };

  gminaEls.forEach((el) => {
    el.setAttribute("aria-pressed", "false");

    el.addEventListener("click", () => activate(el.dataset.gmina));

    el.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        activate(el.dataset.gmina);
      }
    });
  });

  if (select) {
    select.addEventListener("change", () => activate(select.value));
  }

  const initial =
    (select && select.value) ||
    (gminaEls[0] && gminaEls[0].dataset.gmina);

  if (initial) {
    activate(initial);
  }
}
